<template>
  <AppSelect
    :label="$tt(`expected_${type}_port`, { country: $tt(countryKey) })"
    :items="ports.map(p => ({ title: translatePortType(p), value: p }))"
    :hint="$tt('estimate_port_entry')"
    :rules="[required]"
  />
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';

const countryKey = inject(countryKeyInjectionKey)!;
defineProps<{
  type: 'entry' | 'exit';
}>();

const { required } = useValidation();
const { tt } = useLocalization();

const ports = ref<string[]>([]);
setPorts();

async function setPorts() {
  if (countryKey == 'india') ports.value = (await import('~/assets/ports/india-ports.json')).default;
  else if (countryKey == 'vietnam') ports.value = (await import('~/assets/ports/vietnam-ports.json')).default;
  else if (countryKey == 'sri_lanka') ports.value = (await import('~/assets/ports/sri-lanka-ports.json')).default;
  else if (countryKey == 'cambodia') ports.value = (await import('~/assets/ports/cambodia-ports.json')).default;
}

function translatePortType(portName: string) {
  if (portName.includes('Airport')) return portName.replace('Airport', tt('airport'));
  if (portName.includes('Seaport')) return portName.replace('Seaport', tt('seaport'));
  if (portName.includes('Landport')) return portName.replace('Landport', tt('landport'));
  return portName;
}
</script>